import { Button, Icon, TailwindModal, Typography } from 'components'
import { GenericModalProps, TypographyTypes } from 'interfaces'
import React from 'react'

export const ReminderConfirmModal: React.FC<GenericModalProps<string>> = ({
	open,
	setOpen,
	icon,
	descripcion,
	buttonLabel,
	onClickConfirm,
	showCloseButton,
	isDisabledButton = false
}) => {
	return (
		<TailwindModal
			open={open}
			setOpen={setOpen}
			showCloseButton={showCloseButton}
			className="w-[358px] h-auto p-4 rounded-[16px]"
			closeOnOverlayTap={false}
		>
			<div className="flex flex-col justify-center items-center gap-2">
				{icon && (
					<Icon
						src={icon}
						className="h-[40px] w-[40px] text-blue-primary"
						fillPath
					/>
				)}
				{descripcion && (
					<Typography
						type={TypographyTypes.p}
						className="text-[16px] font-normal leading-[24px] text-center pb-2"
						title={descripcion}
						fontLeading="12/12"
					/>
				)}
				<Button
					label={buttonLabel}
					className="!min-w-[118px]"
					color="Primary"
					onClick={onClickConfirm}
					disabled={isDisabledButton}
				/>
			</div>
		</TailwindModal>
	)
}
